import styled from 'styled-components'
import { colors } from '../../../lib/colors'
import { TransitionsAnim } from './Animation'
const { popUpSlideDown, popUpSlideUp } = TransitionsAnim()

interface Error_Styled_props {
  errorType?: boolean
  fadeOut?: boolean
  showLoader?: boolean
}

export const ErrorWrapper = styled.div<Error_Styled_props>`
  ${popUpSlideDown};
  ${(b: any) => (b.fadeOut ? popUpSlideUp : null)};
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: ${({ errorType }: any) =>
    errorType ? 'rgba(28, 28, 33, 0.4)' : ''};
`
export const Err = styled.div<Error_Styled_props>`
  position: absolute;
  top: ${({ showLoader }: any) => (showLoader ? 0 : '41%')};
  left: 50%;
  transform: translate(-50%, 0);
  padding: 15px;
  padding-bottom: 10px;
  background: ${colors.errorBackground};
  border-radius: 5px;
  width: ${({ showLoader }: any) => (showLoader ? '100%' : '')};
  height: ${({ showLoader }: any) => (showLoader ? '100%' : '')};
`
export const Text = styled.div<Error_Styled_props>`
  white-space: nowrap;
  text-transform: uppercase;
  background: ${({ errorType }: any) =>
    errorType
      ? '-webkit-linear-gradient(rgba(219, 46, 46, 1),rgba(228, 48, 48, 1))'
      : '-webkit-linear-gradient(178.89deg, #1F3DB6 14.22%, #2345CA 36.3%, #355AEE 99.05%)'};
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  width: ${({ showLoader }: any) => (showLoader ? '100%' : '')};
  height: ${({ showLoader }: any) => (showLoader ? '100%' : '')};
  display: ${({ showLoader }: any) => (showLoader ? '-webkit-box' : '')};
  align-items: center;
  justify-content: center;
  margin-bottom: 2px;
`
